import React from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';
import ProtectedStorefrontClientPortalRoute from '../components/ProtectedStorefrontClientPortalRoute';
import StorefrontClientPortalLayout from '../layout/StorefrontClientPortalLayout';
import StorefrontAppointmentHistoryPage from '../appointment-history/pages/StorefrontAppointmentHistoryPage';
import StorefrontProfilePage from '../profile/pages/StorefrontProfilePage';
import AppointmentDetails from '../bundle/pages/AppointmentDetails';
import AppointmentCancelConfirmation from '../bundle/pages/AppointmentCancelConfirmation';
import StorefrontClientPaymentSuccessPage from '../../pages/storefront-booking-success/StorefrontClientPaymentSuccessPage';
import CalendarSync from '../bundle/pages/CalendarSync';

const StorefrontClientPortalRoutes = () => (
  <Routes>
    <Route element={<ProtectedStorefrontClientPortalRoute />}>
      <Route element={<StorefrontClientPortalLayout />}>
        <Route index element={<Navigate to="appointments" replace />} />
        <Route path="appointments" element={<StorefrontAppointmentHistoryPage />} />
        <Route path="appointments/:appointmentId" element={<AppointmentDetails />} />
        <Route path="appointments/:appointmentId/cancel-confirmation" element={<AppointmentCancelConfirmation />} />
        <Route
          path="appointments/:appointmentId/success"
          element={<StorefrontClientPaymentSuccessPage />}
        />
        <Route path="profile" element={<StorefrontProfilePage />} />
        <Route path="calendar-sync" element={<CalendarSync />} />
      </Route>
    </Route>
  </Routes>
);

export default StorefrontClientPortalRoutes;
